import request from '@/utils/axios.js'

export function getList () {
  return request({
    url: '/manageMarket/publicAPI/coupon-activity/list',
    method: 'post',
    data: ''
  })
}

// 获取中石化券详情
export function getSnpDetail (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/coupon/getCnpcCheckCode',
    method: 'post',
    data: data
  })
}

// 获取限时抢券列表
export function getSeckillList (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/seckillList',
    method: 'post',
    data: data
  })
}

// 限时抢券 - 用户领用优惠券
export function requestGrantTime (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/grant-time',
    method: 'post',
    data: data
  })
}
